export var BOX_RANGE = '$$range$$';
export var BOX_RANGE_ALIAS = 'low-q1-median-q3-high';
export var BOX_SYNC_NAME = '$$y_outliers$$';
export var OUTLIERS_VIEW_ID = 'outliers_view';